module.exports = __webpack_public_path__ + "static/media/axalogo.19cec6c8.png";